import { useEffect } from "react"

import { useForm } from "react-final-form"

import { useFieldValue } from "components/form/input/NestedField"
import TextInput from "components/form/input/TextInput"
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams"
import FormRow from "components/form/FormRow"

import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields"
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas"
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages"
import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams"
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado"
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao"

import Bio from ".."

export default function BioEditFields({ visita, TipoClass }) {
    const [tipo] = useTipoApontamento()
    const params = visita.cliente.getParams(Bio, tipo, TipoClass)

    const [apontamento] = useFieldValue()

    const form = useForm()

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = Bio.calcConformidade(apontamento, params)
            form.change("coletas", apontamento.coletas)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, params])

    return (
        <>
            <ApontamentoCommonFields visita={visita} showTrator={false} showImplemento={false} showFrente={false} />

            <ApontamentoAmostraParams showTipo={false}>
                <FormRow>
                    <TextInput name="insumo" label="Variedade" />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="M. L. (m):">
                            {params.metroLinear}
                        </ApontamentoParamItem>
                        <ApontamentoParamItem label="C. A. (un.):">
                            {params.canasAvaliadas}
                        </ApontamentoParamItem>
                        <ApontamentoParamItem label="M. A. (m):">
                            {params.metrosAvaliados}
                        </ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoColetas visita={visita}>
                <TextInput type="number" name="peso" label="Peso (kg)" />
                <TextInput type="number" name="perfilhos" label="Perfilhos" />
            </ApontamentoColetas>

            <ApontamentoResultado conformidadeLabel="Resultado (kg)">
            </ApontamentoResultado>
            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    )
}
